import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { createApolloFetch } from 'apollo-fetch';
import { withRouter } from 'react-router';
import { gql } from 'apollo-boost';
import { Mutation } from 'react-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "react-apollo";
import Loader from 'react-loader-spinner';
import Skeleton from '@material-ui/lab/Skeleton';

import {name , url , description , validateForm } from '../../../validations/validation';
// styles and icons
import Logo from '../../../images/logo.png';
import Pp from './images/Pp.png'
import AddIcon from '@material-ui/icons/Add';
import { Navbar, Container, Row, Col } from 'react-bootstrap';
import { Paper, Button, TextField, Typography, InputLabel, FormControl, Select } from '@material-ui/core';

class CompanyProfileReg extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company: '',
            errors : {
                name : '',
                description : '',
                url : ''
            }
        }
    }
    getUserData = () => {
        if (localStorage.jwt) {
            const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
            const uri = 'https://spreago.black-squares.com/graphql';
            let id = JSON.parse(localStorage.jwt).user.id;
            const apolloFetch = createApolloFetch({ uri });
            apolloFetch.use(({ request, options }, next) => {
                if (!options.headers) {
                    options.headers = {};  // Create the headers object if needed.
                }
                options.headers['authorization'] = `Bearer ${token}`;

                next();
            });
            //get user data
                apolloFetch({
                    query:
                        `query($user_id : Int !){
                            user(id: $user_id){
                            company {
                                id
                                name
                                website_url
                                description
                                website_url
                                logo{url}
                                Industry{
                                    id
                                    context
                                    name
                                    name_en
                                    name_ar
                                  }
                              }
                      }
                  }
                   `, variables: {user_id: id}
                })
                    .then(res => {
                        console.log(res.data.user)
                        if (res.data.user && res.data.user.company) {
                            let company = res.data.user.company;
                            this.setState({
                                ...this.state, company: company,
                                profilePic: company.logo ? company.logo.url : '', name: company.name,
                                websiteUrl: company.website_url,
                                description: company.description, industry: company.Industry ? company.Industry.id : ''
                            })
                        }
                    })
            apolloFetch({
                query:
                    `query{
                          companyIndustryType{
                            id
                            context
                            name
                            name_en
                            name_ar
                            created_at
                            updated_at
                          }
                        }
                       `
            })
                .then(res => {
                    let industries = res.data.companyIndustryType;
                    if (industries) {
                        this.setState({ ...this.state, industries: industries });
                    }
                })
        }
    }
    closeProfilePic = () => this.setState({ ...this.state, showProilePic: false });

    handleChange = props => event => {
        this.setState({ ...this.state, [props]: event.target.value });
        console.log(props , event.target.value )
        let errors = this.state.errors;
        errors.form = ''

        switch (props) {
            case 'name':
                errors.name = name(event.target.value);
                break;
            case 'description':
                errors.phone = description(event.target.value);
                break;
            case 'websiteUrl' : 
                errors.url = url(event.target.value);
                break;
            default:
                break;
        }
    };
    checkName = (text) => {
        if (text.length < 3 || text.length > 191) {
            this.setState({ ...this.state, nameErrorMessage: 'Company name must be between 3 and 191 characters long.' });
            return false;

        } else {
            this.setState({ ...this.state, nameErrorMessage: '' });
            return true;
        }
    }
    checkUrl = () => {
        var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;

        if (!this.state.websiteUrl) {
            this.setState({ ...this.state, urlErrorMessage: '' });
            return true;
        } 
        else if (!regex.test(this.state.websiteUrl)) {
            this.setState({ ...this.state, urlErrorMessage: 'Please enter valid url.' });
            return false;
        }
        else {
            this.setState({ ...this.state, urlErrorMessage: '' });
            return true;
        }
    }
    checkImgUrl = (logo) => {
        var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
        if (logo && !regex.test(logo)) {
            console.log(logo);
            return logo = URL.createObjectURL(logo);
        } else {
            console.log(logo);
            return logo
        }
    }
    checkDescription = () => {
        if (this.state.description && this.state.description.length > 5000) {
            this.setState({ ...this.state, descriptionErrorMessage: "This field must be max  5000 characters long." })
            return false;
        } else {
            this.setState({ ...this.state, errorMessage: "" })
            return true;
        }
    }
    componentWillMount() {
        this.getUserData();
    }
    render() {
        const apolloCache = new InMemoryCache({
            addTypename: false
        })
        const token = (localStorage.getItem('jwt')) ? JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token : '';

        const uploadLink = createUploadLink({
            uri: 'https://spreago.black-squares.com/graphql',
            headers: {
                authorization: token ? `Bearer ${token}` : ""
            }
        })
        const client = new ApolloClient({
            cache: apolloCache,
            link: uploadLink
        })
        if (!this.state.industries) {
            return (
                <div>
                    <header className="border-bottom shadow">
                        <Navbar className="container" bg="white" expand="lg">
                            <Link className="navbar-brand" to="/homepage"><img alt="spreago logo" src={Logo} /></Link>
                        </Navbar>
                    </header>
                    <Container className="pt-4 pb-4">
                        <Row>
                            <Col md={8}>
                                <Skeleton className="mb-2" variant="rect" animation="wave" height={460} />
                            </Col>
                            <Col md={4} className="pt-4">
                                <Skeleton variant="text" width={210} height={40} />
                                <Skeleton variant="rect" height={118} />
                            </Col>
                        </Row>
                    </Container>
                </div>
            )
        }
        else {
            return (
                <ApolloProvider client={client}>
                    <div>
                        <header className="border-bottom shadow">
                            <Navbar className="container" bg="white" expand="lg">
                                <Link className="navbar-brand" to="/homepage">
                                    <img alt="spreago logo" src={Logo} />
                                </Link>
                            </Navbar>
                        </header>
                        <Container className="pt-4 pb-4">
                            <Row>
                                <Col md={8}>
                                    <Paper>
                                        <div className="bg-light border-bottom pt-3  pr-4 pl-4">
                                            <h5>Company information</h5>
                                            <p>Please Complete your company profile so you can take all your account benefits</p>
                                        </div>
                                        <div className="p-3  pr-4 pl-4 row m-0">
                                            {/* profile image */}
                                            <Col md={4} className="text-left">
                                                <div className="p-relative m-auto" style={{ width: "170px", height: "170px" }}>
                                                    <img
                                                        style={{ width: '100%', height: '100%' }}
                                                        className="shadow rounded-circle img-fluid"
                                                        src={(this.state.profilePic) ? this.checkImgUrl(this.state.profilePic) : Pp}
                                                        alt="" />
                                                    <button
                                                        className="rounded-circle border-0 btn-orange-gradiant shadow p-absolute"
                                                        style={{ width: "45px", height: "45px", bottom: '0', right: '5px' }}
                                                    >
                                                        <label style={{ cursor: 'pointer' }} for="uploadCompanyProfile">
                                                            <AddIcon className="text-white" style={{ fontSize: "35px" }} />
                                                        </label>
                                                    </button>
                                                    <input
                                                        onChange={e => {
                                                            // make sure that the user attache file
                                                            if (e.target.files[0]) {
                                                                this.setState({ ...this.state, profilePic: e.target.files[0] })
                                                            }
                                                        }}
                                                        type="file"
                                                        accept='image/*'
                                                        className="d-none"
                                                        id="uploadCompanyProfile" />
                                                </div>
                                            </Col>
                                            {/* Company information */}
                                            <Col md={12} className="pt-5">
                                                <InputLabel className="" htmlFor="name">
                                                    <p className="mb-1"> Company Name</p>
                                                </InputLabel>
                                                <TextField
                                                    fullWidth
                                                    id="name"
                                                    color="primary"
                                                    variant="outlined"
                                                    value={this.state.name}
                                                    inputProps={{
                                                        value: this.state.name
                                                    }}
                                                    onChange={this.handleChange('name')}
                                                />
                                            </Col>
                                            <Col xs={12} className="">
                                                <Typography variant="subtitle1" className="text-danger">{this.state.errors.name}</Typography>
                                            </Col>
                                            <Col className="pt-3">
                                                <InputLabel className="mb-1" htmlFor="industry-select">
                                                    Industry
                                                    </InputLabel>
                                                <FormControl size="small" id="industry-select" fullWidth variant="outlined">
                                                    <Select
                                                        className="industry pt-2 pb-2"
                                                        onChange={this.handleChange('industry')}
                                                        inputProps={{
                                                            value: (this.state.industry) ? this.state.industry : ''
                                                        }}
                                                    >
                                                        {
                                                            this.state.industries ? this.state.industries.map(industry => {
                                                                return (
                                                                    <option value={industry.id}>{industry.name}</option>
                                                                );
                                                            }) : ''
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Col>
                                            <Col md={12} className="pt-3">
                                                <InputLabel className="" htmlFor="description">
                                                    <p className="mb-1"> Description</p>
                                                </InputLabel>
                                                <TextField
                                                    fullWidth
                                                    multiline
                                                    rows="3"
                                                    color="primary"
                                                    variant="outlined"
                                                    defaultValue={this.state.description}
                                                    onChange={this.handleChange('description')}
                                                />
                                            </Col>
                                            <Col xs={12} className="">
                                                <Typography variant="subtitle1" className="text-danger">{this.state.errors.description}</Typography>
                                            </Col>
                                            <Col md={12} className="pt-3">
                                                <InputLabel className="" htmlFor="url">
                                                    <p className="mb-1"> Website Url</p>
                                                </InputLabel>
                                                <TextField
                                                    id="url"
                                                    fullWidth
                                                    color="primary"
                                                    variant="outlined"
                                                    inputProps={{
                                                        value: this.state.websiteUrl
                                                    }}
                                                    onChange={this.handleChange('websiteUrl')}
                                                />
                                            </Col>
                                            <Col xs={12} className="">
                                                <Typography variant="subtitle1" className="text-danger">{this.state.errors.url}</Typography>
                                            </Col>
                                            <Col md={6} className="pt-4 text-left">
                                                <div>
                                                    <Link
                                                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                                        to="/homepage" className="border-0 bg-transperant underline"
                                                    >Skip For Now</Link>
                                                </div>
                                            </Col>
                                            <Col md={6} className="pt-4 text-right">
                                                {(this.state.company.id) ?
                                                    <Mutation mutation={EDIT_DATA}>
                                                        {(companyEdit, { data, loading }) =>
                                                            <div>
                                                                <Button
                                                                    type="button"
                                                                    size="large"
                                                                    className="btn-orange-gradiant"
                                                                    variant="contained"
                                                                    onClick={() => {
                                                                        if (validateForm(this.state.errors)) {
                                                                            if (this.state.company.logo) {
                                                                                if (this.state.profilePic === this.state.company.logo.url) {
                                                                                    companyEdit({
                                                                                        variables: {
                                                                                            company_id: this.state.company.id,
                                                                                            name: this.state.name,
                                                                                            website_url: this.state.websiteUrl,
                                                                                            description: this.state.description,
                                                                                            company_industry_type_id: this.state.industry
                                                                                        }
                                                                                    }).then((res, loading) => {
                                                                                        if (res.data.companyEdit.Status.code === 200) {
                                                                                            this.setState({ ...this.state, company: res.data.companyEdit.company });
                                                                                            this.props.history.push({
                                                                                                pathname: '/homepage'
                                                                                            });
                                                                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                                        }

                                                                                    }).catch((err) => console.log(err));
                                                                                } 
                                                                                else {
                                                                                    companyEdit({
                                                                                        variables: {
                                                                                            company_id: this.state.company.id,
                                                                                            name: this.state.name,
                                                                                            website_url: this.state.websiteUrl,
                                                                                            description: this.state.description,
                                                                                            logo: this.state.profilePic,
                                                                                            company_industry_type_id: this.state.industry
                                                                                        }
                                                                                    }).then((res, loading) => {
                                                                                        if (res.data.companyEdit.Status.code === 200) {
                                                                                            this.setState({ ...this.state, company: res.data.companyEdit.company });
                                                                                            this.props.history.push({
                                                                                                pathname: '/homepage'
                                                                                            });
                                                                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                                        }

                                                                                    }).catch((err) => console.log(err));
                                                                                }
                                                                            } 
                                                                            else {
                                                                                companyEdit({
                                                                                    variables: {
                                                                                        company_id: this.state.company.id,
                                                                                        name: this.state.name,
                                                                                        website_url: this.state.websiteUrl,
                                                                                        description: this.state.description,
                                                                                        logo: this.state.profilePic,
                                                                                        company_industry_type_id: this.state.industry
                                                                                    }
                                                                                }).then((res, loading) => {
                                                                                    if (res.data.companyEdit.Status.code === 200) {
                                                                                        this.setState({ ...this.state, company: res.data.companyEdit.company });
                                                                                        this.props.history.push({
                                                                                            pathname: '/homepage'
                                                                                        });
                                                                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                                    }

                                                                                }).catch((err) => console.log(err));
                                                                            }
                                                                        }
                                                                    }} >
                                                                    Save Changes
                                                                </Button>
                                                                {loading &&
                                                                    <div className="loading">
                                                                        {/* <p className="text-white">saving your awesome video addons</p> */}
                                                                        <Loader
                                                                            type="TailSpin"
                                                                            color="white"
                                                                            height={50}
                                                                            width={50}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                    </Mutation>
                                                    :
                                                    <Mutation mutation={SAVE_DATA}>
                                                        {(companyCreate, { data, loading }) =>
                                                            <div>
                                                                <Button
                                                                    type="button"
                                                                    size="large"
                                                                    className="btn-orange-gradiant"
                                                                    variant="contained"
                                                                    onClick={() => {
                                                                        if (validateForm(this.state.errors)) {
                                                                            companyCreate({
                                                                                variables: {
                                                                                    name: this.state.name,
                                                                                    website_url: this.state.websiteUrl,
                                                                                    description: this.state.description,
                                                                                    logo: this.state.profilePic,
                                                                                    company_industry_type_id: this.state.industry
                                                                                }
                                                                            }).then((res, loading) => {
                                                                                console.log(res)
                                                                                if (res.data.companyCreate.Status.code === 200) {
                                                                                    this.setState({ ...this.state, company: res.data.companyCreate.company });
                                                                                    this.props.history.push({
                                                                                        pathname: '/homepage'
                                                                                    });
                                                                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                                }

                                                                            }).catch((err) => console.log(err));
                                                                        }
                                                                    }} >
                                                                    Save Changes
                                                                </Button>
                                                                {loading &&
                                                                    <div className="loading">
                                                                        {/* <p className="text-white">saving your awesome video addons</p> */}
                                                                        <Loader
                                                                            type="TailSpin"
                                                                            color="white"
                                                                            height={50}
                                                                            width={50}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                    </Mutation>
                                                }
                                            </Col>
                                        </div>
                                    </Paper>
                                </Col>
                                <Col md={4}>
                                    <div className="pt-4">
                                        <h5>Company profile </h5>
                                        <p>
                                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                                            sed diam nonumy.Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                                            sed diam nonumy. Lorem ipsum dolor sit amet,
                                            consetetur sadipscing elitr, sed diam nonumy.Lorem ipsum dolor sit amet, consetetur .
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </ApolloProvider>
            )
        }
    }
}

const SAVE_DATA = gql`
mutation($name : Name! $description :Text $website_url : Url  $logo : Upload $company_industry_type_id : Int){
    companyCreate(Inputs:{
      name : $name 
      website_url : $website_url
      description : $description
      logo : $logo
      company_industry_type_id  : $company_industry_type_id
    }){
      Status {
        code
        message
      }
      company {
        id
        name
        website_url
        description
        website_url
        logo{id}
        Industry{
            id
            context
            name
            name_en
            name_ar
          }
      }
    }
  }
`
const EDIT_DATA = gql`
mutation($name : Name! $description :Text $website_url : Url  $logo : Upload $company_id : Int $company_industry_type_id : Int){
    companyEdit(Inputs:{
            name : $name 
            website_url : $website_url
            description : $description
            logo : $logo
            company : {
                id : $company_id
            }
            company_industry_type_id  : $company_industry_type_id
    }){
      Status{
        code
        message
      }
      company {
        id
        name
        website_url
        description
        website_url
        logo{id}
        Industry{
            id
            context
            name
            name_en
            name_ar
          }
      }
    }
  }  
`

export default (withRouter(CompanyProfileReg));